"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnalyticsEvent", {
  enumerable: true,
  get: function () {
    return _analyticsEvent.AnalyticsEvent;
  }
});
Object.defineProperty(exports, "AnalyticsQueue", {
  enumerable: true,
  get: function () {
    return _queueEvents.AnalyticsQueue;
  }
});
Object.defineProperty(exports, "docComplete", {
  enumerable: true,
  get: function () {
    return _docComplete.docComplete;
  }
});
var _analyticsEvent = require("./analytics-event");
var _docComplete = require("./docComplete");
var _queueEvents = require("./queue-events");

//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@att-bit/ui-frameworks.components.analytics-event/dist/index.js
// module id = 233
// module chunks = 8